<div class="col-md-12 mb-30" [hidden]="Selected_Offtime_Record.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Hourly Leave List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Status </label>
          <select [(ngModel)]="Filter_Status" name="Filter_Status" class="custom-select">
            <option value="0">All</option>
            <option value="1">Under Review</option>
            <option value="2">Rejected</option>
            <option value="3">Approved</option>

          </select>
        </div>
      </div>
      <div class="row">

        <div class="form-group col-md-3">
          <label for="exampleInputEmail1"> Personnel </label>
          <app-PersonOption (OnBack_Person_Action)="OnGet_Person_Action($event)">
          </app-PersonOption>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="ReadData_Offtime(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info"
            style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
          <button *ngIf="!Procssing" (click)="exportexcel()" type="button" class="btn btn-warning"
            style="margin-right: 5px;"><i class="fa   fa-file-excel-o"></i> Excel </button>
          <button *ngIf="!Procssing" routerLink="/OffTimeForm" type="button" class="btn btn-success"
            style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add New Record </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Request ID</th>
              <th>Full Name</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Working Day</th>

              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of DataList_Offtime
                  | paginate
                          : {
                              id: 'DataList_FeildTable',
                              itemsPerPage: 50,
                              currentPage: page,
                              totalItems: DataList_Offtime.length
                            }">

              <tr>
                <td rowspan="2">{{DataList_Offtime.indexOf(item)+1}}</td>
                <td>{{item.id}}</td>
                <td>{{item.fullname}}</td>
                <td>{{item.startTime}}</td>
                <td>{{item.endTime}}</td>
                <td>{{item.requestDate}}</td>

                <td>
                  <p *ngIf="item.status==1" style="color: rgb(20, 77, 220);">Under Review</p>
                  <p *ngIf="item.status==2" style="color: #489b39;">Approve</p>
                  <p *ngIf="item.status==3" style="color: crimson;">Reject</p>
                </td>

                <td rowspan="2">
                  <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                    <div class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                        <a href="{{BaseUrl1}}{{item.flowchart.flochart_id}}{{BaseUrlCo}}{{item.flowchart.makerId}}"
                          target="_blank" class="dropdown-item"><i class="fa fa-wpbeginner"></i>
                          Workflow
                        </a>
                        <a style="cursor: pointer;" (click)="ReadData_History(item)" class="dropdown-item"><i
                            class="fa fa-history"></i>
                          Workflow History
                        </a>

                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <th>Description</th>
                <td colspan="5">{{item.dsc}}</td>
              </tr>

            </ng-container>

          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>




<div *ngIf="Selected_Offtime_Record.id>0" class="card card-statistics mb-30">

  <div class="card-body">
    <div class="tab nav-border" style="position: relative;">
      <div class="d-block d-md-flex justify-content-between">
        <div class="d-block w-100">
          <h5 class="card-title border-0 pb-0">Request Workflow History '{{Selected_Offtime_Record.flowchart.uniCode}}'
          </h5>
        </div>
      </div>
      <div class="tab-content" id="myTabContent">

        <div class="tab-pane fade active show" id="order" role="tabpanel" aria-labelledby="months-tab">
          <div class="row mb-30">
            <app-FlowchartHistory [DataList_History]="DataList_History"></app-FlowchartHistory>
          </div>
          <button *ngIf="!InProccessing && canDeleteHistoryRecord && DataList_Peyvast.length==1" type="button"
            (click)="DeleteLetterHistoryRecord()" class="btn btn-danger"><i class="fa fa-remove"></i>Delete Last
            Referral</button>
        </div>


      </div>
    </div>
  </div>


  <div class="card-body">
    <button (click)="Close_Show_History()" type="button" class="btn btn-warning" style="margin-right: 5px;"> Back
    </button>
  </div>

</div>








<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>
      <th>Request ID</th>
      <th>Full Name</th>
      <th>Start Time</th>
      <th>End Time</th>
      <th>Working Day</th>

      <th>Status</th>

      <th>Description</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Offtime">
      <td>{{DataList_Offtime.indexOf(item)+1}}</td>
      <td>{{item.id}}</td>
      <td>{{item.fullname}}</td>
      <td>{{item.startTime}}</td>
      <td>{{item.endTime}}</td>
      <td>{{item.requestDate}}</td>

      <td>
        <p *ngIf="item.status==1" style="color: rgb(20, 77, 220);">Under Review</p>
        <p *ngIf="item.status==2" style="color: #489b39;">Approve</p>
        <p *ngIf="item.status==3" style="color: crimson;">Reject</p>
      </td>
      <td>{{item.dsc}}</td>

    </tr>
  </tbody>
</table>